import { Column, Columns, Box } from 'braid-design-system';
import React from 'react';

import type {
  ClientListingForListingsTab,
  ListingProductForListingsTab,
} from 'src/types/graphql-derived';

import Actions from './components/Actions/Actions';
import Statistics from './components/Statistics/Statistics';

import * as styles from './style.css';

interface DetailsProps {
  listing: ClientListingForListingsTab;
  postFunction: () => void;
  expireFunction: () => void;
  isProcessing: boolean;
  listingProducts: ListingProductForListingsTab[];
}

const Details = ({
  listing,
  postFunction,
  expireFunction,
  isProcessing,
  listingProducts,
}: DetailsProps) => (
  <Column>
    <Columns space="small" collapseBelow="tablet" reverse={true}>
      <Column>
        <Box className={styles.mobileOutline}>
          <Statistics listing={listing} />
        </Box>
      </Column>
      <Column>
        <Actions
          listing={listing}
          postFunction={postFunction}
          expireFunction={expireFunction}
          isProcessing={isProcessing}
          listingProducts={listingProducts}
        />
      </Column>
    </Columns>
  </Column>
);

export default Details;
